// Holds the singleton redux store so non-React modules (e.g. the fetcher and
// the property actions) can read the active property id and dispatch without
// prop drilling or a circular import of the app entry. Set once at startup in
// index.jsx.
let _store: { getState: () => any; dispatch: (a: any) => any } | null = null;

export function setStoreInstance(s: {
  getState: () => any;
  dispatch: (a: any) => any;
}) {
  _store = s;
}

export function getStore() {
  return _store;
}

/** The id of the currently-selected property (multi-home), or null. */
export function getActiveHomeId(): number | null {
  try {
    const id = _store?.getState?.()?.Home?._id;
    return typeof id === "number" && id > 0 ? id : null;
  } catch {
    return null;
  }
}
